import { types } from "../types/types";

const initialState = {
  showModal: {},
}; 

export const newModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.getModalComponent:
      return {
        ...state,
        showModal: { ...action.payload },
      };
    case types.authLogout:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
